import '@hotwired/turbo'
import './scripts/glightbox';
import './css/app.scss'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import './scripts/scrollbarWidth'

// Start Stimulus application
const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context));
application.debug = process.env.NODE_ENV === 'development';

// Automatically add all images to the manifest.json
const imagesCtx = require.context('./images', false, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesCtx.keys().forEach(imagesCtx);

window.addEventListener('load', () => {
    document.querySelectorAll('.swiper-container').forEach((sc) => {
        if (sc.swiper) {
            sc.swiper.update();
        }
    });
});

// Trigger a custom event when an Instagram embed has loaded
window.__igEmbedLoaded = (item) => {
    document.dispatchEvent(new CustomEvent('igEmbedLoaded', {detail: item}));
}

// Always break out of a missing frame
document.documentElement.addEventListener('turbo:frame-missing', (e) => {
    e.preventDefault();
    e.detail.visit(e.detail.response);
});

// Make external ads default consent
document.addEventListener('DOMContentLoaded', () => {
    const cookieId = parseInt(document.documentElement.dataset.aditionCookieId) || 29;

    if (null !== localStorage.getItem('external-ads-accepted')) {
        return;
    }

    if (cookiebar.issetCookie(cookieId)) {
        return;
    }

    if (!cookiebar.get().settings.cookies['_'+cookieId]) {
        return;
    }

    if (!window.cookiebar) {
        return;
    }

    cookiebar.get().settings.cookies['_'+cookieId].confirmed = true;
    const storage = cookiebar.getStorage();
    storage.cookies.push(parseInt(cookieId));
    localStorage.setItem(cookiebar.get().settings.token+'_'+cookiebar.get().settings.configId, JSON.stringify(storage));
});
